import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';
import toLower from 'lodash/fp/toLower';

export default function getPropertyData({ content }) {
	return {
		property_name: get(['analytics', 'channel'])(content),
		property_code: flow(get(['bookingConfig', 'orsCode']), toLower)(content),
		property_region: get(['location', 'enRegion'])(content),
		property_subregion: get(['location', 'enCountry'])(content),
	};
}
